module.exports = __webpack_public_path__ + "img/yaguangmofakoudai.min.3308e690.png";